/** Locked SDS PDF footer copy (§3.3 State A / State B). */

export const SDS_STATE_A_AI_DRAFT_NOTICE =
  "DRAFT — Generated with AI assistance. Chemical identity, concentrations, hazard classifications, and regulatory details must be independently verified before workplace use.";

export const SDS_STATE_A_SUPPLIER_PRECEDENCE =
  "When a manufacturer or distributor SDS is available, use that document instead of this draft.";

export const SDS_STATE_A_NOT_LEGAL_ADVICE =
  "Turbo Assist does not provide EHS or legal compliance certification.";

export const SDS_STATE_B_ATTESTATION_LEAD = "Reviewed and verified by";

export const SDS_STATE_B_ATTESTATION_BODY =
  "The reviewer confirmed this Safety Data Sheet was read and the chemical details are correct for use at";

export const SDS_STATE_B_AI_ORIGIN_NOTE =
  "Originally AI-drafted; human review completed before publication.";

export const SDS_SUPPLIER_VERIFIED_LEAD = "Supplier SDS on file · verified by";

export const SDS_BINDER_COVER_NOTICE =
  "Individual SDS pages include per-sheet review attestation or AI draft notice as applicable.";

export const SDS_BINDER_DRAFT_INTERIM_NOTICE =
  "Draft sheets are included until publish ships — verify before workplace use.";

export const SDS_PUBLISH_AI_CHECKBOX =
  "I have reviewed this SDS and verified the chemical details are correct.";

export const SDS_PUBLISH_SUPPLIER_CHECKBOX =
  "I confirm this is the correct manufacturer/distributor SDS for this material.";

export const SDS_EDIT_AFTER_PUBLISH_CONFIRM =
  "This will create a new draft and restore the AI disclaimer until you sign off again. Continue?";

export function formatSdsStateAGenerationStamp(args: {
  generatedAt?: string | null;
  generatedByUserId?: string | null;
  promptVersion?: string | null;
  sourceInputsHash?: string | null;
  source?: string | null;
}): string {
  const parts: string[] = [];
  if (args.generatedAt) parts.push(`generated_at=${args.generatedAt}`);
  if (args.generatedByUserId) parts.push(`generated_by=${args.generatedByUserId}`);
  if (args.promptVersion) parts.push(`prompt=${args.promptVersion}`);
  if (args.sourceInputsHash) parts.push(`hash=${args.sourceInputsHash}`);
  if (parts.length === 0) {
    return `Manual draft · source=${args.source || "manual"}`;
  }
  return parts.join(" · ");
}

export function formatSdsStateBAttestationLine(args: {
  reviewerDisplayName: string;
  reviewedAtLocal: string;
  organizationName: string;
}): string {
  const name = args.reviewerDisplayName.trim() || "Reviewer";
  return `${SDS_STATE_B_ATTESTATION_LEAD} ${name} · ${args.reviewedAtLocal} · ${args.organizationName}`;
}

export function formatSdsSupplierVerifiedLine(args: {
  reviewerDisplayName: string;
  reviewedAtLocal: string;
}): string {
  const name = args.reviewerDisplayName.trim() || "Reviewer";
  return `${SDS_SUPPLIER_VERIFIED_LEAD} ${name} · ${args.reviewedAtLocal}`;
}
